export class Score {

  public lineScore: number = 0;
  public pointScore: number = 0;
  public vitesse: number = 0;

  constructor(){
    this.lineScore = 0;
    this.pointScore = 0;
    this.vitesse = 0;
  }

}
